/* ==========================================================================
   KASUPP — product finder quizzes
   One question per screen, live product recommendations pulled from the
   storefront JSON so results are never stale.
   ========================================================================== */
(function () {
  'use strict';

  /* ------------------------------------------------------------------ data */

  var QUIZZES = {
    'fat-burner': {
      title: 'Fat Burner Finder',
      intro: 'Five questions. We match you to a formula that fits how you actually train, sleep, and handle caffeine.',
      disclaimer:
        'Weight-management products are intended to complement balanced nutrition and regular activity. They are not a replacement for either, and no result is guaranteed.',
      questions: [
        {
          id: 'goal',
          q: 'What are you working on right now?',
          help: 'Pick the closest — you can always browse everything afterwards.',
          options: [
            { label: 'Losing fat while keeping muscle', tags: ['protect-muscle'] },
            { label: 'General weight management', tags: [] },
            { label: 'Controlling appetite and cravings', tags: ['appetite'] },
            { label: 'Keeping energy up while eating less', tags: ['energy'] }
          ]
        },
        {
          id: 'stims',
          q: 'How do you handle caffeine and stimulants?',
          help: 'This is the single biggest factor in whether a fat burner works for you.',
          options: [
            { label: 'Fine — I drink coffee daily and want the kick', tags: ['stim-high'] },
            { label: 'Moderate — one coffee is plenty', tags: ['stim-mid'] },
            { label: 'Sensitive — they make me jittery or anxious', tags: ['stim-free'] },
            { label: 'I avoid stimulants entirely', tags: ['stim-free'] }
          ]
        },
        {
          id: 'timing',
          q: 'When would you take it?',
          options: [
            { label: 'First thing in the morning', tags: [] },
            { label: 'Before training', tags: ['pre'] },
            { label: 'Afternoon slump', tags: [] },
            { label: 'Evening — after work', tags: ['stim-free'] }
          ]
        },
        {
          id: 'training',
          q: 'How often do you train?',
          options: [
            { label: 'Not yet — starting out', tags: ['beginner'] },
            { label: '1–2 times a week', tags: [] },
            { label: '3–4 times a week', tags: ['active'] },
            { label: '5+ times a week', tags: ['active', 'protect-muscle'] }
          ]
        },
        {
          id: 'extras',
          q: 'Anything else you want covered?',
          help: 'Choose as many as apply.',
          multi: true,
          options: [
            { label: 'Blood sugar and cravings', tags: ['glucose'] },
            { label: 'Water retention', tags: ['water'] },
            { label: 'Digestion', tags: ['digestion'] },
            { label: 'Filling nutrition gaps while cutting', tags: ['foundation'] },
            { label: 'Nothing else — keep it simple', tags: [] }
          ]
        }
      ],
      result: function (tags) {
        var stimFree = tags['stim-free'] > 0;
        var primary = stimFree
          ? {
              handle: 'fat-burners-stim-free',
              title: 'Stimulant-free weight management',
              why:
                'You told us stimulants are a problem, or that you would take this late in the day. A stimulant-free formula gives you the support without the jitters or the wrecked sleep — and poor sleep is one of the fastest ways to stall progress.'
            }
          : {
              handle: 'fat-burners-stimulant',
              title: 'Thermogenic fat burners',
              why:
                'You tolerate stimulants and you are taking it earlier in the day, so a thermogenic formula fits. Start with the lowest serving on the label to assess tolerance before going further.'
            };

        var add = [];
        if (tags['protect-muscle']) {
          add.push({
            handle: 'amino-acids',
            title: 'Amino acids',
            why: 'In a calorie deficit, protein and amino intake is what protects the muscle you already built.'
          });
        }
        if (tags['foundation'] || tags['active']) {
          add.push({
            handle: 'multivitamins',
            title: 'A daily multivitamin',
            why: 'Eating less means fewer nutrients in. A multivitamin is the cheapest insurance in the whole cart.'
          });
        }
        if (tags['glucose'] && !stimFree) {
          add.push({
            handle: 'fat-burners-stim-free',
            title: 'Blood-sugar support',
            why: 'Chromium and similar ingredients sit in this range and stack fine alongside a thermogenic.'
          });
        }
        if (tags['digestion']) {
          add.push({ handle: 'wellness', title: 'Digestive support', why: 'Digestive comfort makes a diet far easier to stick to.' });
        }
        return { primary: primary, add: add.slice(0, 2) };
      }
    },

    'natural-muscle': {
      title: 'Natural Muscle Builder',
      intro: 'Five questions to find what actually moves the needle for your training age — no synthetic hormones involved.',
      disclaimer:
        'These are nutritional products intended to support a training routine. Training, protein intake, and sleep do the heavy lifting.',
      questions: [
        {
          id: 'experience',
          q: 'How long have you been training consistently?',
          options: [
            { label: 'Just getting started', tags: ['beginner'] },
            { label: '6 months to 2 years', tags: ['intermediate'] },
            { label: '2 to 5 years', tags: ['advanced'] },
            { label: '5+ years', tags: ['advanced'] }
          ]
        },
        {
          id: 'goal',
          q: 'What is the goal for the next few months?',
          options: [
            { label: 'Add size', tags: ['size'] },
            { label: 'Get stronger', tags: ['strength'] },
            { label: 'Recomp — leaner and stronger', tags: ['recomp'] },
            { label: 'Recover better between sessions', tags: ['recovery'] }
          ]
        },
        {
          id: 'creatine',
          q: 'Are you already taking creatine?',
          help: 'It is the most researched sports supplement there is, so this matters.',
          options: [
            { label: 'No, never tried it', tags: ['needs-creatine'] },
            { label: 'I have before, not currently', tags: ['needs-creatine'] },
            { label: 'Yes, daily', tags: ['has-creatine'] }
          ]
        },
        {
          id: 'limiter',
          q: 'What is holding you back most?',
          options: [
            { label: 'Energy and focus in the gym', tags: ['pre'] },
            { label: 'Soreness between sessions', tags: ['recovery', 'joints'] },
            { label: 'Sleep quality', tags: ['sleep'] },
            { label: 'Nothing specific — I want to optimise', tags: ['foundation'] }
          ]
        },
        {
          id: 'days',
          q: 'How many days a week do you lift?',
          options: [
            { label: '1–2', tags: [] },
            { label: '3–4', tags: ['active'] },
            { label: '5–6', tags: ['active', 'recovery'] },
            { label: 'Every day', tags: ['active', 'recovery', 'joints'] }
          ]
        }
      ],
      result: function (tags) {
        var primary;
        if (tags['needs-creatine']) {
          primary = {
            handle: 'creatine',
            title: 'Start with creatine',
            why:
              'You are not currently taking it, and it is the single best-supported supplement for strength and size. Nothing else on this page will do more per dollar.'
          };
        } else if (tags['pre']) {
          primary = {
            handle: 'pre-workout',
            title: 'Pre-workout and pump support',
            why: 'You already have creatine covered, and energy in the gym is your limiter. This is the next lever.'
          };
        } else if (tags['recovery']) {
          primary = {
            handle: 'amino-acids',
            title: 'Amino acids and recovery',
            why: 'Training frequency is high and recovery is the bottleneck, so this is where to spend next.'
          };
        } else {
          primary = {
            handle: 'muscle',
            title: 'Muscle and strength',
            why: 'You have the basics covered — this is the full range for strength-focused routines.'
          };
        }

        var add = [];
        if (tags['needs-creatine'] && tags['pre']) {
          add.push({ handle: 'pre-workout', title: 'Pre-workout', why: 'Pairs with creatine for training-day energy.' });
        }
        if (tags['advanced'] && (tags['size'] || tags['strength'])) {
          add.push({
            handle: 'test-support',
            title: 'Natural testosterone support',
            why: 'You have training years behind you — this is the natural, non-hormonal end of that category.'
          });
        }
        if (tags['sleep']) {
          add.push({ handle: 'sleep-stress', title: 'Sleep support', why: 'Muscle is built while you sleep. Fix this before adding anything else.' });
        }
        if (tags['joints']) {
          add.push({ handle: 'joint-support', title: 'Joint support', why: 'High training frequency puts the joints under load too.' });
        }
        if (!add.length) {
          add.push({ handle: 'multivitamins', title: 'A daily multivitamin', why: 'The foundation under everything else.' });
        }
        return { primary: primary, add: add.slice(0, 2) };
      }
    },

    prohormone: {
      title: 'Prohormone Questionnaire',
      intro:
        'A short screening to work out whether a hormonally active product is appropriate for you at all — and which part of the range fits if it is.',
      gated: true,
      disclaimer:
        'Hormonally active supplements are for healthy adults over 21 with real training experience. They are not for women, anyone under 21, or anyone taking medication or managing a medical condition. Read every label in full and speak with a qualified healthcare professional before use.',
      questions: [
        {
          id: 'age',
          q: 'How old are you?',
          options: [
            { label: 'Under 21', tags: ['disqualify'] },
            { label: '21–29', tags: [] },
            { label: '30–44', tags: [] },
            { label: '45 or older', tags: ['older'] }
          ]
        },
        {
          id: 'experience',
          q: 'How many years have you trained consistently with structured nutrition?',
          help: 'Honest answers give you a useful result.',
          options: [
            { label: 'Less than 2 years', tags: ['disqualify'] },
            { label: '2–4 years', tags: ['eligible'] },
            { label: '5+ years', tags: ['eligible', 'experienced'] }
          ]
        },
        {
          id: 'medical',
          q: 'Do you take any medication, or manage any medical condition?',
          help: 'Including blood pressure, cholesterol, liver, heart, or mental-health medication.',
          options: [
            { label: 'Yes', tags: ['disqualify'] },
            { label: 'No', tags: [] },
            { label: 'Not sure', tags: ['disqualify'] }
          ]
        },
        {
          id: 'history',
          q: 'Have you used a hormonally active supplement before?',
          options: [
            { label: 'Never', tags: ['first-timer'] },
            { label: 'Once', tags: [] },
            { label: 'Several times', tags: ['experienced'] }
          ]
        },
        {
          id: 'goal',
          q: 'What is the goal?',
          options: [
            { label: 'Lean gains', tags: ['lean'] },
            { label: 'Maximum size', tags: ['bulk'] },
            { label: 'Cutting while holding muscle', tags: ['cut'] }
          ]
        }
      ],
      result: function (tags) {
        if (tags['disqualify']) {
          return {
            blocked: true,
            title: 'A hormonally active product is not the right call here',
            why:
              'Based on your answers — age, training experience, or medication — this category is not appropriate for you, and we are not going to sell it to you. That is not a sales tactic: the risk is real and the payoff at your stage is smaller than what training, protein, and creatine will give you.',
            primary: {
              handle: 'natural-muscle-alt',
              title: 'Build the base first',
              why: 'This is where the actual results are for the next 12 months.'
            }
          };
        }
        return {
          primary: {
            handle: 'prohormones',
            title: 'Prohormones and anabolic precursors',
            why:
              'You meet the screening criteria. Read the full label before you buy, follow the directions exactly, and do not run two hormonally active products at once.'
          },
          add: [
            {
              handle: 'cycle-support',
              title: 'Cycle support — not optional',
              why:
                'Liver and organ support belongs in the same order, not the next one. Anyone selling you the first without the second is not looking after you.'
            },
            {
              handle: 'test-support',
              title: 'Post-cycle support',
              why: 'Plan the end before you start. Buy it now so it is on the shelf when you need it.'
            }
          ]
        };
      }
    },

    'prohormone-cycle': {
      title: 'Cycle Support Builder',
      intro:
        'Builds the complete stack around a hormonally active product — compound, on-cycle support, post support, and foundation. We do not give dosages or cycle lengths: follow the label on what you buy.',
      gated: true,
      disclaimer:
        'For healthy adults over 21 with training experience. Not for women, anyone under 21, or anyone taking medication or managing a medical condition. This tool recommends product categories only — it is not a protocol, and it is not medical advice. Speak with a qualified healthcare professional before use.',
      questions: [
        {
          id: 'age',
          q: 'How old are you?',
          options: [
            { label: 'Under 21', tags: ['disqualify'] },
            { label: '21–29', tags: [] },
            { label: '30 or older', tags: [] }
          ]
        },
        {
          id: 'experience',
          q: 'Training experience with structured nutrition?',
          options: [
            { label: 'Less than 2 years', tags: ['disqualify'] },
            { label: '2–4 years', tags: ['eligible'] },
            { label: '5+ years', tags: ['eligible', 'experienced'] }
          ]
        },
        {
          id: 'medical',
          q: 'Any medication or medical condition?',
          options: [
            { label: 'Yes, or not sure', tags: ['disqualify'] },
            { label: 'No', tags: [] }
          ]
        },
        {
          id: 'phase',
          q: 'What phase are you planning?',
          options: [
            { label: 'Lean gains', tags: ['lean'] },
            { label: 'Bulk', tags: ['bulk'] },
            { label: 'Cut', tags: ['cut'] }
          ]
        },
        {
          id: 'have',
          q: 'What do you already have on the shelf?',
          multi: true,
          options: [
            { label: 'Liver and organ support', tags: ['has-support'] },
            { label: 'Estrogen management', tags: ['has-estrogen'] },
            { label: 'Post-cycle support', tags: ['has-pct'] },
            { label: 'A daily multivitamin', tags: ['has-multi'] },
            { label: 'None of these', tags: [] }
          ]
        }
      ],
      result: function (tags) {
        if (tags['disqualify']) {
          return {
            blocked: true,
            title: 'We are not going to build you a stack',
            why:
              'Your answers put you outside the group this category is intended for — under 21, under two years of training, or on medication. Any store willing to sell you a cycle anyway is telling you something about that store. Build the base instead; it is where your next 15 pounds actually comes from.',
            primary: { handle: 'natural-muscle-alt', title: 'Natural muscle building', why: 'Creatine, protein, aminos, and consistency.' }
          };
        }

        var stack = [
          {
            handle: 'prohormones',
            title: '1 — The compound',
            why: 'Pick one. Never two at once. Read the entire label before you order.'
          }
        ];
        if (!tags['has-support']) {
          stack.push({
            handle: 'cycle-support',
            title: '2 — On-cycle support',
            why: 'Liver and organ support runs alongside, from day one. This is the part people skip and regret.'
          });
        }
        if (!tags['has-pct']) {
          stack.push({
            handle: 'test-support',
            title: '3 — Post support',
            why: 'The end of a cycle matters more than the middle. Have it before you start.'
          });
        }
        if (!tags['has-multi']) {
          stack.push({
            handle: 'multivitamins',
            title: '4 — Foundation',
            why: 'Micronutrients and omegas underneath the whole thing.'
          });
        }
        if (tags['cut']) {
          stack.push({ handle: 'fat-burners-stim-free', title: '5 — Cut support', why: 'Stimulant-free, so it does not stack badly with the rest.' });
        }

        return { primary: stack[0], add: stack.slice(1), stack: true };
      }
    },

    general: {
      title: 'General Supplement Advice',
      intro: 'Not sure where to start? Five questions and we will point you at the two or three things that actually matter for you.',
      disclaimer:
        'General information only, not medical advice. Talk to a qualified healthcare professional about your individual needs, especially if you are pregnant, nursing, taking medication, or managing a condition.',
      questions: [
        {
          id: 'goal',
          q: 'What matters most to you right now?',
          options: [
            { label: 'Everyday energy', tags: ['energy'] },
            { label: 'Weight management', tags: ['weight'] },
            { label: 'Building muscle and strength', tags: ['muscle'] },
            { label: 'General health and filling gaps', tags: ['foundation'] }
          ]
        },
        {
          id: 'diet',
          q: 'How would you describe your diet?',
          options: [
            { label: 'Pretty solid most days', tags: [] },
            { label: 'Hit and miss', tags: ['foundation'] },
            { label: 'Restricted — vegan, low calorie, or allergy-driven', tags: ['foundation', 'gaps'] },
            { label: 'Honestly, poor', tags: ['foundation', 'gaps'] }
          ]
        },
        {
          id: 'activity',
          q: 'How active are you?',
          options: [
            { label: 'Mostly sedentary', tags: [] },
            { label: 'Walking and light activity', tags: [] },
            { label: 'Training 3–4 times a week', tags: ['active'] },
            { label: 'Training 5+ times a week', tags: ['active', 'recovery'] }
          ]
        },
        {
          id: 'concerns',
          q: 'Anything specific you would like to support?',
          multi: true,
          options: [
            { label: 'Sleep', tags: ['sleep'] },
            { label: 'Stress', tags: ['sleep'] },
            { label: 'Joints', tags: ['joints'] },
            { label: 'Digestion', tags: ['digestion'] },
            { label: 'Immunity', tags: ['immunity'] },
            { label: "Women's health", tags: ['womens'] }
          ]
        },
        {
          id: 'simplicity',
          q: 'How much are you willing to take daily?',
          options: [
            { label: 'One thing. Keep it simple.', tags: ['minimal'] },
            { label: 'Two or three is fine', tags: [] },
            { label: 'I will take whatever works', tags: ['maximal'] }
          ]
        }
      ],
      result: function (tags) {
        var primary;
        if (tags['muscle']) primary = { handle: 'muscle', title: 'Muscle and strength', why: 'Your stated goal, and where your money should go first.' };
        else if (tags['weight']) primary = { handle: 'weight-management', title: 'Weight management', why: 'Alongside nutrition and activity, not instead of them.' };
        else if (tags['energy']) primary = { handle: 'energy', title: 'Energy and focus', why: 'Start here, but check your sleep before adding stimulants.' };
        else primary = { handle: 'multivitamins', title: 'A daily multivitamin', why: 'The single most sensible starting point when the diet is inconsistent.' };

        var add = [];
        if (tags['minimal']) {
          return { primary: primary, add: [] };
        }
        if (tags['foundation'] && primary.handle !== 'multivitamins') {
          add.push({ handle: 'multivitamins', title: 'A daily multivitamin', why: 'Covers the gaps your diet leaves.' });
        }
        if (tags['sleep']) add.push({ handle: 'sleep-stress', title: 'Sleep and stress', why: 'Fix this and everything else gets easier.' });
        if (tags['joints']) add.push({ handle: 'joint-support', title: 'Joint support', why: 'Worth starting before it becomes a problem.' });
        if (tags['immunity'] || tags['digestion']) add.push({ handle: 'wellness', title: 'Daily wellness', href: true, why: 'Immune and digestive support live here.' });
        if (tags['womens']) add.push({ handle: 'womens-wellness', title: "Women's wellness", why: 'Formulas made specifically for women.' });
        if (tags['recovery']) add.push({ handle: 'amino-acids', title: 'Recovery support', why: 'Training that often, recovery is the limiter.' });
        return { primary: primary, add: add.slice(0, tags['maximal'] ? 3 : 2) };
      }
    }
  };

  // Fallback used by the blocked results.
  var ALT = { 'natural-muscle-alt': 'muscle' };

  /* ---------------------------------------------------------------- helpers */

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  function money(value) {
    var format = (window.KASUPP && window.KASUPP.moneyFormat) || '${{amount}}';
    var num = Number(value).toFixed(2);
    return format.replace(/\{\{\s*amount\s*\}\}/, num);
  }

  var productCache = {};

  function fetchProducts(handle, limit) {
    var real = ALT[handle] || handle;
    var key = real + ':' + limit;
    if (productCache[key]) return productCache[key];
    productCache[key] = fetch('/collections/' + real + '/products.json?limit=' + limit)
      .then(function (r) { return r.json(); })
      .then(function (d) { return (d.products || []).filter(function (p) { return p.variants && p.variants.length; }); })
      .catch(function () { return []; });
    return productCache[key];
  }

  function productCard(p) {
    var v = p.variants[0];
    var img = (p.images && p.images[0] && p.images[0].src) || '';
    var card = el('div', 'quiz-product');
    card.innerHTML =
      '<a class="quiz-product__media" href="/products/' + p.handle + '">' +
      (img ? '<img src="' + img.replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2') + '" alt="' + (p.title || '').replace(/"/g, '') + '" loading="lazy" width="200" height="200">' : '') +
      '</a>' +
      '<div class="quiz-product__body">' +
      '<a class="quiz-product__title" href="/products/' + p.handle + '">' + p.title + '</a>' +
      '<span class="quiz-product__price">' + money(v.price) + '</span>' +
      '</div>' +
      (v.available
        ? '<button type="button" class="btn btn--sm btn--accent quiz-product__add" data-quick-add="' + v.id + '">Add to cart</button>'
        : '<span class="badge badge--muted">Sold out</span>');
    return card;
  }

  /* ------------------------------------------------------------------ quiz */

  function Quiz(root, key) {
    var def = QUIZZES[key];
    if (!def) return;

    var state = { step: -1, answers: {}, tags: {} };
    var storeKey = 'kasupp-quiz-' + key;

    function addTags(tags) {
      tags.forEach(function (t) { state.tags[t] = (state.tags[t] || 0) + 1; });
    }

    function recomputeTags() {
      state.tags = {};
      def.questions.forEach(function (q) {
        var a = state.answers[q.id];
        if (a == null) return;
        (Array.isArray(a) ? a : [a]).forEach(function (i) {
          if (q.options[i]) addTags(q.options[i].tags || []);
        });
      });
    }

    function save() {
      try { localStorage.setItem(storeKey, JSON.stringify(state.answers)); } catch (e) {}
    }

    function render() {
      root.innerHTML = '';
      if (state.step === -1) return renderIntro();
      if (state.step >= def.questions.length) return renderResult();
      renderQuestion(def.questions[state.step]);
    }

    function renderIntro() {
      var wrap = el('div', 'quiz-card quiz-card--intro');
      wrap.appendChild(el('p', 'section__eyebrow', 'Find your fit'));
      wrap.appendChild(el('h2', 'h2', def.title));
      wrap.appendChild(el('p', 'lede', def.intro));

      if (def.gated) {
        var gate = el('div', 'quiz-gate');
        gate.innerHTML =
          '<p class="quiz-gate__title">Before you start</p>' +
          '<p>' + def.disclaimer + '</p>' +
          '<label class="quiz-gate__check"><input type="checkbox" id="quiz-gate-' + key + '"> ' +
          'I am over 21, not pregnant or nursing, not taking medication, and I understand this tool does not provide medical advice.</label>';
        wrap.appendChild(gate);
      }

      var start = el('button', 'btn btn--accent btn--lg', def.gated ? 'I understand — start' : 'Start the quiz');
      start.type = 'button';
      if (def.gated) {
        start.disabled = true;
        gateCheckbox(wrap, start);
      }
      start.addEventListener('click', function () {
        state.step = 0;
        render();
      });
      wrap.appendChild(start);

      var meta = el('p', 'quiz-meta', def.questions.length + ' questions · about 45 seconds · no email required');
      wrap.appendChild(meta);
      root.appendChild(wrap);
    }

    function gateCheckbox(wrap, button) {
      setTimeout(function () {
        var cb = wrap.querySelector('#quiz-gate-' + key);
        if (!cb) return;
        cb.addEventListener('change', function () { button.disabled = !cb.checked; });
      }, 0);
    }

    function renderQuestion(q) {
      var wrap = el('div', 'quiz-card');

      var pct = Math.round((state.step / def.questions.length) * 100);
      var bar = el('div', 'quiz-progress');
      bar.innerHTML = '<span style="width:' + pct + '%"></span>';
      wrap.appendChild(bar);
      wrap.appendChild(el('p', 'quiz-step', 'Question ' + (state.step + 1) + ' of ' + def.questions.length));

      wrap.appendChild(el('h2', 'h3 quiz-question', q.q));
      if (q.help) wrap.appendChild(el('p', 'quiz-help', q.help));

      var list = el('div', 'quiz-options');
      var selected = state.answers[q.id];

      q.options.forEach(function (opt, i) {
        var btn = el('button', 'quiz-option', opt.label);
        btn.type = 'button';
        var isSel = q.multi ? Array.isArray(selected) && selected.indexOf(i) !== -1 : selected === i;
        if (isSel) btn.classList.add('is-selected');

        btn.addEventListener('click', function () {
          if (q.multi) {
            var arr = Array.isArray(state.answers[q.id]) ? state.answers[q.id].slice() : [];
            var at = arr.indexOf(i);
            if (at === -1) arr.push(i); else arr.splice(at, 1);
            state.answers[q.id] = arr;
            btn.classList.toggle('is-selected');
            save();
          } else {
            state.answers[q.id] = i;
            save();
            state.step += 1;
            recomputeTags();
            render();
            root.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
        list.appendChild(btn);
      });
      wrap.appendChild(list);

      var nav = el('div', 'quiz-nav');
      if (state.step > 0) {
        var back = el('button', 'link-arrow', 'Back');
        back.type = 'button';
        back.addEventListener('click', function () { state.step -= 1; render(); });
        nav.appendChild(back);
      } else {
        nav.appendChild(el('span'));
      }
      if (q.multi) {
        var next = el('button', 'btn btn--accent', 'Continue');
        next.type = 'button';
        next.addEventListener('click', function () {
          state.step += 1;
          recomputeTags();
          render();
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        nav.appendChild(next);
      }
      wrap.appendChild(nav);
      root.appendChild(wrap);
    }

    function renderResult() {
      recomputeTags();
      var res = def.result(state.tags);
      var wrap = el('div', 'quiz-card quiz-card--result');

      wrap.appendChild(el('p', 'section__eyebrow', res.blocked ? 'Our honest answer' : 'Your match'));
      wrap.appendChild(el('h2', 'h2', res.blocked ? res.title : res.primary.title));
      wrap.appendChild(el('p', 'lede', res.blocked ? res.why : res.primary.why));

      var groups = res.blocked ? [res.primary] : [res.primary].concat(res.add || []);

      groups.forEach(function (g, idx) {
        var block = el('div', 'quiz-rec');
        if (idx > 0 || res.stack) {
          block.appendChild(el('p', 'quiz-rec__title', g.title));
          block.appendChild(el('p', 'quiz-rec__why', g.why));
        }
        var grid = el('div', 'quiz-products');
        block.appendChild(grid);

        var link = el('a', 'link-arrow', 'See all ' + g.title.toLowerCase().replace(/^\d+\s*—\s*/, ''));
        link.href = '/collections/' + (ALT[g.handle] || g.handle);
        block.appendChild(link);

        fetchProducts(g.handle, idx === 0 ? 4 : 3).then(function (products) {
          if (!products.length) {
            grid.appendChild(el('p', 'quiz-help', 'Nothing in stock in this category right now.'));
            return;
          }
          products.forEach(function (p) { grid.appendChild(productCard(p)); });
        });

        wrap.appendChild(block);
      });

      if (!res.blocked && res.stack) {
        var addAll = el('button', 'btn btn--accent btn--lg btn--full', 'Add the full stack to cart');
        addAll.type = 'button';
        addAll.addEventListener('click', function () {
          var ids = Array.prototype.slice
            .call(wrap.querySelectorAll('.quiz-rec'))
            .map(function (b) { var f = b.querySelector('[data-quick-add]'); return f && f.getAttribute('data-quick-add'); })
            .filter(Boolean);
          addMany(ids, addAll);
        });
        wrap.appendChild(addAll);
      }

      var foot = el('div', 'quiz-result__foot');
      var again = el('button', 'link-arrow', 'Start over');
      again.type = 'button';
      again.addEventListener('click', function () {
        state = { step: -1, answers: {}, tags: {} };
        try { localStorage.removeItem(storeKey); } catch (e) {}
        render();
      });
      foot.appendChild(again);
      wrap.appendChild(foot);

      wrap.appendChild(el('p', 'disclaimer', def.disclaimer));
      root.appendChild(wrap);
    }

    function addMany(ids, button) {
      if (!ids.length) return;
      button.classList.add('loading');
      var chain = Promise.resolve();
      ids.forEach(function (id) {
        chain = chain.then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: Number(id), quantity: 1 })
          });
        });
      });
      chain
        .then(function () { window.location.href = '/cart'; })
        .finally(function () { button.classList.remove('loading'); });
    }

    render();
  }

  /* ------------------------------------------------------------------ init */

  function init() {
    document.querySelectorAll('[data-quiz]').forEach(function (root) {
      if (root.dataset.mounted === 'true') return;
      root.dataset.mounted = 'true';
      Quiz(root, root.getAttribute('data-quiz'));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
